import {
  ADMIN_GET_OPS_DASHBOARD,
  ADMIN_GET_STUCK_QUEUE_AGGREGATE
} from '../lib/constant';

const initialState = {
  opsDashboard: null,
  stuckQueue: null
};

export default function opsDashboard(state = initialState, action) {
  switch (action.type) {
  case ADMIN_GET_OPS_DASHBOARD:
    return {...state, opsDashboard: action.payload};
  case ADMIN_GET_STUCK_QUEUE_AGGREGATE:
    return {...state, stuckQueue: action.payload};
  default:
    return state;
  }
}
